/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  homes.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/7/4 14:44
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
import { assignParams, axiosAPIUrl, Parameter } from './index'

/* 应用 */
export class ApplicationDto {
  applicationId?: string // 应用id
  applicationName?: string // 应用名字
  applicationLogo?: string // 应用图片地址链接
  partnerCompanyId?: string // 合作方公司id（默认为南瓜头）
  parentId?: string // 分组id
  parentName?: string // 分组名称
  route?: string // 路由
  custom?: string // 是否自定义（0系统，1自定义）
  isAddShow?: boolean // 是否显示应用添加按钮 (已经加入常用应用的就不显示)
  action?: string // 权限控制的权限标识
  children?: ApplicationDto[]
  checked!: boolean // 是否选中
}

export class bannerDto {
  advertisementId?: string //	广告id
  pictureName?: string //		广告名字
  picture?: string //		广告图片
  deliverArea?: string //		投递区域 （0同时投递，1首页，2资讯页）
  jumpLinks?: string //		跳转链接（预留）
  companyId?: string // 合作方id
}

/* 资讯  */
export class InformationListDto {
  information_id?: string // 资讯id
  title?: string // 标题
  hightTitle?: string // 标题高亮字段
  cover?: string // 封面url
  content?: string // 内容url
  visitsNumber?: string // 浏览次数
  companyShortName?: string // 公司名字
  informationSynopsis?: string // 资讯简介
}

/* AM001获取全部应用-普通用户 */
export function getApplication (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjoperation/applicationManage/getApplication',
    method: 'post',
    data: {...params, ...assignParams()},
    extraParams: { showLoading: false }
  })
}

/**
 * 首页获取实时概况
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getActualByDate (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjorder/IS/getActualByDate',
    method: 'post',
    data:{...params, ...assignParams()},
    extraParams: { showLoading: false }
  })
}

/* 7.8 查询应用&资讯 */
export function searchApplicationOrInformation (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjoperation/applicationManage/searchApplicationOrInformation',
    method: 'post',
    data: {...params, ...assignParams()}
  })
}

/* 7.6 添加常用应用  =====> 作废*/
export function addApplicationFavorite (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjoperation/applicationManage/addApplicationFavorite',
    method: 'post',
    data: {...params, ...assignParams()},
  })
}

/* 7.7 移除常用应用  =====> 作废*/
export function deleteApplicationFavorite (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjoperation/applicationManage/deleteApplicationFavorite',
    method: 'post',
    data:{...params, ...assignParams()},
  })
}

/* 7.10 移动常用应用  =====> 作废*/
export function moveApplicationFavorite (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjoperation/applicationManage/moveApplicationFavorite',
    method: 'post',
    data: {...params, ...assignParams()},
  })
}

/* 7.11 用户更新常用应用列表  */
export function modifyApplicationListFavorite (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjoperation/applicationManage/modifyApplicationListFavorite',
    method: 'post',
    data: {...params, ...assignParams()},
    extraParams:{ showLoading: false }
  })
}

/* 7.9 获取指定类型应用-普通用户 */
export function getApplicationByParent (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjoperation/applicationManage/getApplicationByParent',
    method: 'post',
    data: {...params, ...assignParams()},
  })
}

/* 7.10 普通用户获取广告列表 */
export function getAdvertisementList (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjSystemAudit/AM/getAdvertisementList',
    method: 'get',
    params:{...params, ...assignParams()},
    extraParams:{ showLoading: false }
  })
}
